import React, { useId } from "react";
import { AttributeOption, ProductAttribute } from "./types"; // or wherever you defined it
import { PriceDisplay } from "./PriceDisplay";
import style from "./productlist.module.scss";

interface AttributeSelectorProps {
  options: AttributeOption[];
  selectedOptionId?: number;
  onChange: (selected: AttributeOption) => void;
  cssClass?: string;
  attribute: ProductAttribute;
}

export const AttributeSelectList: React.FC<AttributeSelectorProps> = ({
  options,
  selectedOptionId,
  onChange,
  cssClass,
  attribute,
}) => {
  const selectListId = useId();

  const [enableBlank, setEnableBlank] = React.useState(true);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const fieldValue = event.target.value;

    if (fieldValue === "") {
      return;
    }

    const selectedId = parseInt(fieldValue, 10);
    const selected = options.find((opt) => opt.Id === selectedId);
    if (selected) {
      onChange(selected);
      setEnableBlank(false); // don't allow the blank option once something has been selected.
    }
  };

  return (
    <>
      <label className={style.attributeName} htmlFor={selectListId}>
        {attribute.Name}
      </label>

      <select
        id={selectListId}
        value={selectedOptionId ?? ""}
        onChange={handleChange}
        className={`form-control ${cssClass}`}
      >
        <option value={0} disabled={!enableBlank}>
          Select an option
        </option>
        {options.map((opt) => (
          <option key={opt.Id} value={opt.Id}>
            {opt.Name}{" "}
            <PriceDisplay
              opt={opt}
              displayZero=""
              wrap={(content) => <>({content})</>}
            ></PriceDisplay>
          </option>
        ))}
      </select>
    </>
  );
};
